const isProduction = window.location.host === 'antwar.io';
const initialState = 'state-play';

let vueApp = new Vue({
    el: '#app',
    mounted: function() {
        game.appComponent = this;
        this.updateIsPlayScreen();
        this.$root.$on('changeState', (newState) => {
            this.changeState(newState);
        });
    },
    data: function() {
        return {
            chats: null,
            isPlayScreen: game.isPlayScreen,
            currentState: null,
            navStates: [
                {
                    name: 'Profile',
                    state: 'state-profile',
                    icon: 'fa-user'
                },
                {
                    name: 'Play',
                    state: 'state-play',
                    icon: 'fa-play'
                },
                {
                    name: 'Shop',
                    state: 'state-shop',
                    icon: 'fa-shopping-basket'
                },
                {
                    name: 'Friends',
                    state: 'state-friends',
                    icon: 'fa-users'
                },
                {
                    name: 'Leaderboard',
                    state: 'state-leaderboards',
                    icon: 'fa-list-alt'
                }
            ]
        };
    },
    methods: {
        changeState: function(newState) {
            this.currentState = newState;
            this.$refs.app.scrollTop = 0;
        },
        updateIsPlayScreen: function(disableUserInit) {
            this.isPlayScreen = game.isPlayScreen;
            this.chats = [];
            if (game.isPlayScreen && !isMobile && !game.isSingleplayer) {
                this.chats = [];
                let lobbyChat = {
                    name: 'Game Chat',
                    user: null,
                    messages: []
                };
                this.chats.push(lobbyChat);
                game.lobbyChat = lobbyChat;

                let teamChat = {
                    name: 'Team Chat',
                    channel: 'team',
                    user: null,
                    messages: []
                };
                this.chats.push(teamChat);
                game.teamChat = teamChat;
            }

            let generalChat = null;
            if (!game.isPlayScreen && !isMobile) {
                this.chats = [];
                if (game.services.user?.currentUser?.isDev) {
                    generalChat = {
                        name: 'General Chat',
                        user: null,
                        messages: []
                    };
                    this.chats.push(generalChat);

                    function addChatMessage(data) {
                        if (generalChat && generalChat.component) {
                            generalChat.component.addChatMessage(data);
                        }
                    }

                    this.$root.$on('menuSocketCreated', (menuSocket) => {
                        menuSocket.on('connect', function () {
                            console.info('Connected to master server.');
                            addChatMessage({message: 'Connected to chat.'});
                        });

                        menuSocket.on('connect_error', function () {
                            addChatMessage({message: 'Failed to connect to chat.'});
                        });

                        menuSocket.on('error', function (err) {
                            addChatMessage({message: 'Failed to connect to chat.'});
                        });

                        menuSocket.on('chat', function (data) {
                            addChatMessage(data);
                        });

                        menuSocket.on('disconnect', function () {
                            console.info('Disconnected from master server.');
                            addChatMessage({message: 'Disconnected from chat.'});
                        });
                    });
                }
            }

            if (!disableUserInit && !game.isPlayScreen) {
                if (Cookies.get('token')) {
                    game.services.user.initUser(this).then(() => {
                        this.changeState(initialState);
                    }, () => {
                        this.changeState(initialState);
                    });
                } else {
                    this.changeState(initialState);
                }
            }
            this.$forceUpdate();
        }
    },
    template: `
    <div ref="app">
        <div v-if="isPlayScreen">
            <app-game-round-end></app-game-round-end>
            <app-game-queen-menu></app-game-queen-menu>
            <app-game-lobby></app-game-lobby>
            <app-game-game-menu></app-game-game-menu>
            <app-game-player-menu></app-game-player-menu>
            <div class="app-chat" v-if="chats">
                <app-chat v-for="chat in chats" v-bind:chatData="chat"></app-chat>
            </div>
        </div>
        <div class="app" v-if="!isPlayScreen">
            <app-header></app-header>
            <div class="app-nav">
                <button v-for="nav in navStates" :key="nav.state" class="app-nav-button" 
                    type="button"
                    v-on:click="changeState(nav.state)"
                    v-bind:class="{'app-nav-button-selected':currentState===nav.state}">
                    <i class="app-nav-button-icon fa" v-bind:class="[nav.icon]"></i>
                    <div class="app-nav-button-text">{{nav.name}}</div>
                </button>
            </div>
            <div class="app-content-container">
                <div class="app-content">
                    <div class="app-content-inner">
                        <component v-bind:is="currentState"></component>
                    </div>
                </div>
            </div>
            <div class="app-chat" v-if="chats">
                <app-chat v-for="chat in chats" v-bind:chatData="chat"></app-chat>
            </div>
            
            <div class="footer">
                <a href="#" onclick="event.preventDefault();" data-toggle="modal" data-target="#aboutModal">About</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://bombsightgames.com/legal/tos" target="_blank">Terms of Service</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://bombsightgames.com/legal/privacy_policy" target="_blank">Privacy Policy</a>&nbsp;&nbsp;|&nbsp;&nbsp;
                <a href="https://bombsightgames.com/legal/cookie_policy" target="_blank">Cookie Policy</a>
                <br>
                Copyright © 2021 <a href="https://bombsightgames.com/" target="_blank">Bombsight Games</a>. All Rights Reserved.
            </div>
        </div>
    </div>
    `
});

function cleanUri() {
    let uri = window.location.toString();
    let clean_uri = uri.substring(0, uri.indexOf("?"));
    window.history.replaceState({}, document.title, clean_uri);
}

function startPlayScreen(isSingleplayer, isSandbox) {
    $('#ad-menu').remove();

    game.loadSounds();

    game.isPlayScreen = true;
    game.isSingleplayer = isSingleplayer;
    game.isSandbox = isSandbox;
    if (isSingleplayer || (game.queryData && game.queryData.token)) {
        game.services.ad.hideBannerAd();
        cleanUri();
    } else {
        window.location = '/';
    }

    game.services.socket.disconnectMenuSocket();

    game.appComponent.updateIsPlayScreen();

    $('.game-menu-button').show();
}
game.startPlayScreen = startPlayScreen;

game.calculateRank = function(xp) {
    return Math.floor(RANK_CONSTANT * Math.sqrt(xp));
};

function getQuery() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for(var i = 0; i < hashes.length; i++)
    {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

(function() {
    game.menuSocket = null;
    game.queryData = getQuery();

    if (game.isPlayScreen) {
        startPlayScreen();
    } else {
        if (game.queryData && (game.queryData.token || game.queryData.invite)) {
            cleanUri();
        }

        if (isMobile || self !== top) {
            $('body').css({
                'overflow-y': 'auto'
            });
        }
    }

    setTimeout(function() {
        ga('send', 'pageview');
    }, 200);
})();